export const ORDER_LIST = "order_list";
export const ORDER_LIST_FULL = "order_list_full";
export const ORDER_CHANGE_STATUS = "order_change_status";
